export default "__VITE_ASSET__DOCuHcVP__"